// extracted by mini-css-extract-plugin
export default {"link":"YWHjL7XVRSV_aqe_q6hr","body":"jMtMuFlLen_KgRybjbNO"};